import cn from 'classnames';
import React, { memo } from 'react';

import { Avatar } from '@sravni/react-design-system';
import type { CONTAINER_SIZES } from '@sravni/react-design-system/dist/types/constants/sizes';
import { COMMON_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import type { Tab } from '@sravni/ugc/lib/specialOffers/types';

import styles from '../../../block.module.scss';

interface IProps {
  isCard: boolean;
  logoSrc: string;
  tabType: Tab;
  size?: typeof CONTAINER_SIZES[keyof typeof CONTAINER_SIZES];
}

export const Logo = memo(({ isCard, logoSrc, tabType, size = 44 }: IProps) => {
  if (isCard) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={logoSrc} loading="lazy" alt="" className={styles.cardImage} />
      </div>
    );
  }

  return (
    <Avatar
      src={logoSrc}
      size={size}
      className={cn(tabType[0] === COMMON_OFFERS.loan && styles['avatar--with-border'])}
    />
  );
});
